export function receivedData(state, data) {
  state.data = data;
  state.isLoading = false;
}

export function startLoading(state, itemsPerPage) {
  state.data = [];
  state.isLoading = true;
}
